import { VisuallyHidden } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './NavCount.module.css';

export interface NavCountProps {
  children: ReactNode;
  variant?: 'neutral' | 'risk';
  /** Read instead of the pill text, e.g. "5 problems need your action" for a bare "5". */
  label?: string;
}

export function NavCount({ children, variant = 'neutral', label }: NavCountProps) {
  const cls = variant === 'risk' ? `${classes.count} ${classes.risk}` : classes.count;
  if (!label) {
    return <span className={cls}>{children}</span>;
  }
  return (
    <>
      <span className={cls} aria-hidden="true">
        {children}
      </span>
      <VisuallyHidden>{label}</VisuallyHidden>
    </>
  );
}
